class DropdownListItem extends elementorModules.frontend.handlers.Base
{
    onInit()
    {
        super.onInit();

        this.Dropdown = new Hogo.Dropdown( this.elements.$component, this.getOptions() );
    }

    getOptions()
    {
        return {};
    }

    getDefaultSettings()
    {
        return {
            selectors: {
                component: '[data-component="dropdown"]',
            },
        };
    }

    getDefaultElements()
    {
        const selectors = this.getSettings( 'selectors' );

        const element = this.$element[0];

        return {
            $component: element.querySelector( selectors.component ),
        };
    }
}

export default ($scope) => {
    elementorFrontend.elementsHandler.addHandler(DropdownListItem, { $element: $scope });
};